import { pxToRem } from '@/shared/styles/themes'
import { Grid, styled } from '@mui/material'

export const StyledLogoWrapper = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-right: ${pxToRem(15)};

  ${props => props.theme.breakpoints.up('sm')} {
    margin-right: ${pxToRem(16)};
  }
  
  ${props => props.theme.breakpoints.up('md')} {
    margin-right: ${pxToRem(24)};
  } 
`

export const StyledCategoriesGrid = styled(Grid)`
  display: none;
  
  ${props => props.theme.breakpoints.up('md')} {
    display: block;
    height: 100%;
    margin-right: ${pxToRem(44)};
    margin-left: ${pxToRem(16)};
  }
`

export const StyledDesktopSearchContainer = styled(Grid)`
  flex: 1;
  margin-right: ${pxToRem(8)};
  display: none;

  ${props => props.theme.breakpoints.up('md')} {
    display: flex;
  }
`

export const StyledRightMenuContainer = styled(Grid)`
`